import { render, staticRenderFns } from "./DisabledPostStatus.vue?vue&type=template&id=19cfbd88&"
import script from "./DisabledPostStatus.vue?vue&type=script&lang=js&"
export * from "./DisabledPostStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports